import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonListHeader, IonLoading, IonModal, IonTitle, IonToast } from '@ionic/react';
import { arrowBack, locationOutline } from 'ionicons/icons';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import "./VendasCriarProjeto.css";

import { useHistory } from 'react-router';
import { cadastraEquipe, incluirProjeto, listaEquipePorPerfil, requestService } from '../../../../../Utils/Services';
import AppTypeaheadList from '../../../../../components/AppTypeaheadList';
import { useGooglePlacesSimple } from '../../../../../components/useGooglePlacesSimple';
import { MessageContext } from '../../../../../contexts/MessageContext';

type Props = {
  dadosVenda: any;
  inputRef: any;
  closeAction: Function;
  salvarAction: Function;
};

const VendasCriarProjeto: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [showModalResponsaveis, setShowModalResponsaveis] = useState(false);
  const [responsaveis, setResponsaveis] = useState<any>([]);
  const [selectedResponsaveis, setSelectedResponsaveis] = useState<any>([]);
  const [selectedResponsaveisText, setSelectedResponsaveisText] = useState<string>('0 Responsáveis');
  const [lojas, setLojas] = useState<string>(JSON.parse(window.localStorage.getItem("lojas") || "[]")[0]?.empresaLojaId || "");
  const [nomeProjeto, setNomeProjeto] = useState<any>();
  const [descricaoProjeto, setDescricaoProjeto] = useState<any>();
  const [checked, setChecked] = useState(false);
  const [checkedInterno, setCheckedInterno] = useState(false);
  const [esconderBloqueado, setEsconderBloqueado] = useState(false);

  const [local, setLocal] = useState<any>("");
  const [complemento, setComplemento] = useState<any>("");
  const [enderecoLat, setEnderecoLat] = useState<any>("");
  const [enderecoLng, setEnderecoLng] = useState<any>("");
  const [ignorarProximaMudanca, setIgnorarProximaMudanca] = useState(false);
  const { loja, setLoja } = useContext(MessageContext);
  const [botaoAtivo, setBotaoAtivo] = useState(true);
  const { recarregarProjeto, setRecarregarProjeto } = useContext(MessageContext);

  const { pkUsuario, setPkUsuario } = useContext(MessageContext);

  const [mostartAlerta] = useIonAlert();
  const [localEnderecoSelecionado, setLocalEnderecoSelecionado] = useState<any>("");
  const [listaEnderecos, setListaEnderecos] = useState<any>([]);

  // Hook do Google Places Simple
  const {
    listaEnderecos: listaEnderecosGoogle,
    buscandoEndereco: loadingEnderecos,
    buscarSugestoes: buscarSugestoesEndereco,
    buscarDetalhes: buscarDetalhesEndereco,
    limparSugestoes: limparSugestoesEndereco
  } = useGooglePlacesSimple({
    onError: (mensagem: string) => {
      setTextToast(mensagem);
      setShowToast(true);
    },
    onLoading: setShowLoading
  });


  useEffect(() => {

    if (props.dadosVenda) {
      console.log("entrou no useEffect");
      avancarProjeto();
    }
  }, [props.dadosVenda]);

  useEffect(() => {
    // Define o foco no input quando o componente é montado
    if (props.inputRef.current) {
      props.inputRef.current.focus();
    }
  }, [props.inputRef]);

  // Função para buscar detalhes e preencher campos automaticamente
  const handleBuscarDetalhesEndereco = useCallback(async (placeId: string, enderecoFormatado: string) => {
    try {
      const detalhes = await buscarDetalhesEndereco(placeId, enderecoFormatado);
      if (detalhes && detalhes.sucesso) {
        setLocal(detalhes.endereco);
        setEnderecoLat(detalhes.latitude);
        setEnderecoLng(detalhes.longitude);

        // Limpar sugestões após seleção
        limparSugestoesEndereco();
      }
    } catch (error) {
      console.error('Erro ao buscar detalhes do endereço:', error);
    }
  }, [buscarDetalhesEndereco, limparSugestoesEndereco]);

  // Função para lidar com seleção de item da lista de sugestões
  const handleSelectItemEndereco = useCallback((item: any) => {
    // Ativa flag para ignorar próxima mudança (evita busca automática)
    setIgnorarProximaMudanca(true);

    // Busca detalhes completos do endereço selecionado
    handleBuscarDetalhesEndereco(item.placeId, item.descricao);
  }, [handleBuscarDetalhesEndereco]);

  function validarCampos() {

    if (nomeProjeto.length === 0 || local.length === 0) {
      console.log("************ n validou");
      setTextToast("Todos os campos com * são obrigatórios.");
      setShowToast(true);
      return false;
    }
    return true;
  }

  function avancarProjeto() {

    console.log("props.dadosVenda", props.dadosVenda);
    setDescricaoProjeto("");
    setNomeProjeto(props.dadosVenda.nomeVenda);
    setComplemento("");
    setEnderecoLat("");
    setEnderecoLng("");
    setIgnorarProximaMudanca(false);
    limparSugestoesEndereco();

    if (props.dadosVenda.enderecoVenda) {
      setLocal(props.dadosVenda.enderecoVenda);
      setEsconderBloqueado(true);
    }
    else {
      setLocal("");
      setEsconderBloqueado(false);
    }
    setChecked(false);
    setCheckedInterno(false);
    // setSelectedResponsaveis([]);
    // setSelectedResponsaveisText("0 Responsáveis");

    setBotaoAtivo(true);
    consultarUsuarios();
  }

  async function CriarCliente(): Promise<any> {
    return new Promise((resolve, reject) => {
      const objectRequest = {
        cpf: props.dadosVenda?.prospectCpf?.replace("-", "").replace(".", "").replace(".", ""),
        nome: props.dadosVenda.prospectNome,
        telefone: props.dadosVenda?.prospectTelefone,
        email: props.dadosVenda?.prospectEmail,
        dataAniversario: props.dadosVenda.prospectDataAniversario,
        endereco: local || "",
        enderecoLat: enderecoLat,
        enderecoLng: enderecoLng,
        complemento: complemento,
        color: "",
        perfil: "cliente",
        empresaMarca: localStorage.getItem("empresaMarca") || "",
        lojas: JSON.parse(window.localStorage.getItem("lojas") || "[]").filter((value: any) => {
          return lojas.includes(value.empresaLojaId);
        })
      }

      console.log("objectRequest", objectRequest);

      requestService(cadastraEquipe.url, {
        method: cadastraEquipe.method,
        headers: [["token", localStorage.getItem("token") || ""]],
        credentials: 'include',
        body: JSON.stringify(objectRequest)
      },
        history,
        (response: any) => {
          resolve(response); // Resolvendo a promessa com a resposta
        },
        (error: any) => {
          reject(error); // Rejeitando a promessa com o erro
        });
    });
  }


  async function inserirProjeto(response: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let objRequest = {
        "nomeProjeto": nomeProjeto,
        "descricaoProjeto": descricaoProjeto,
        "endereco": response.usuario.endereco,
        "enderecoLat": response.usuario.enderecoLat,
        "enderecoLng": response.usuario.enderecoLng,
        "complemento": response.usuario.complemento,
        "vendaid": props.dadosVenda.pk,
        "clienteid": response.usuario.pk,
        "empresaid": props.dadosVenda.gsi3pk,
        "responsaveis": selectedResponsaveis,
        "interno": checkedInterno,
      };

      console.log("objRequest", objRequest);

      requestService(incluirProjeto.url, {
        method: incluirProjeto.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
        history,
        (response: any) => {
          resolve(response); // Resolvendo a promessa com a resposta        
        },
        (error: any) => {
          reject(error); // Rejeitando a promessa com o erro
        });
    });
  }



  const formatData = (data: string[]) => {
    if (data.length === 1) {
      const responsavel = responsaveis.find((convidado: any) => convidado.pk === data[0])!;
      return responsavel.nome;
    }

    return `${data.length} Responsáveis`;
  };


  const responsavelSelectionChanged = (responsaveis: any[]) => {

    if (responsaveis.length > 0) {
      setSelectedResponsaveis(responsaveis);
      setSelectedResponsaveisText(formatData(responsaveis));
    }
    else {
      setSelectedResponsaveis([]);
      setSelectedResponsaveisText("0 Responsáveis");
    }
    setShowModalResponsaveis(false);
  };


  const consultarUsuario = async () => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let montarUrl = listaEquipePorPerfil.url.replace("{loja}", loja.replaceAll(/#/g, "%23")).concat("?status=ativo");

    const resp = await fetch(montarUrl.replace("{perfil}", "usuario"),
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let equipe = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (equipe.Items) {
        return equipe.Items;
      }
    }
  }

  const consultarUsuarios = async () => {

    let ret2 = await consultarUsuario();
    console.log("ret2", ret2);

    let lista = (ret2.sort((a: any, b: any) => (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : -1))
    setResponsaveis(lista);

    const responsavelSelecionado = lista.find((convidado: any) => convidado.pk === pkUsuario);

    console.log("responsavelSelecionado", responsavelSelecionado);

    if (responsavelSelecionado) {
      setSelectedResponsaveis([responsavelSelecionado.pk]);
      setSelectedResponsaveisText(responsavelSelecionado.nome);
    }
  }

  function readListaEnderecos() {
    return listaEnderecos.map((value: any, index: any) => (
      <IonItem
        key={"endereco" + value.place_id}
        button
        onClick={() => setLocalEnderecoSelecionado(value.formatted_address)}
        color={localEnderecoSelecionado === value.formatted_address ? 'tertiary' : ''}
      >
        <IonLabel>{value.formatted_address}</IonLabel>
      </IonItem>
    ));
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonTitle>Criar {window.localStorage.getItem("servicoTipo") || "Projeto"}</IonTitle>
          <IonButtons slot="start">
            <IonButton onClick={() => {
              props.closeAction();
            }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={false}>
        <IonList lines="full" class="ion-no-margin">
          <IonListHeader lines="full">
            <IonLabel>
              Dados {window.localStorage.getItem("servicoTipo") || "Projeto"}
            </IonLabel>
          </IonListHeader>
          <IonItem lines="none">
            <IonLabel>Nome*</IonLabel>
            <IonInput placeholder="Nome" value={nomeProjeto} ref={(ref) => props.inputRef.current = ref}
              autoCorrect='true' autoCapitalize='true'
              required onIonInput={(e: any) => setNomeProjeto(e.target.value)}></IonInput>
          </IonItem>

          <IonItem lines="none" hidden={esconderBloqueado}>
            <IonLabel>Endereço*</IonLabel>
            <IonInput
              placeholder="Avenida Paulista, 111, São Paulo"
              value={local}
              autoCorrect='true'
              autoCapitalize='true'
              required
              onIonInput={(e: any) => {
                const valor = e.target.value || "";
                setLocal(valor);

                // Se flag estiver ativa, ignorar busca (foi preenchimento automático)
                if (ignorarProximaMudanca) {
                  setIgnorarProximaMudanca(false);
                  return;
                }

                // Buscar sugestões automaticamente
                buscarSugestoesEndereco(valor);
              }}
              onKeyDown={(e: any) => {
                // Enter força busca imediata
                if (e.key === "Enter") {
                  e.preventDefault();
                  const valor = local || '';
                  if (valor.trim().length >= 4) {
                    buscarSugestoesEndereco(valor, true);
                  } else {
                    setTextToast('Digite no mínimo 4 caracteres para buscar.');
                    setShowToast(true);
                  }
                }
              }}
            ></IonInput>
          </IonItem>

          {/* Lista de sugestões do Google Places */}
          {listaEnderecosGoogle?.length > 0 && !esconderBloqueado && (
            <IonItem lines="none" style={{ padding: '0px 0px' }}>
              <IonList
                style={{
                  padding: '0px',
                  width: '100%',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  maxHeight: '197px',
                  overflowY: 'auto',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
              >
                {listaEnderecosGoogle.map((item: any, index: any) => {
                  // console.log("Item da lista:", item);
                  return (
                    <IonItem
                      lines={index < listaEnderecosGoogle.length - 1 ? "full" : "none"}
                      key={"sugestao" + index}
                      button
                      onClick={() => handleSelectItemEndereco(item)}
                    >
                      <IonIcon
                        icon={locationOutline}
                        slot="start"
                        color='primary'
                        style={{ fontSize: '20px', marginRight: '12px' }}
                      />
                      <IonLabel style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '4px', color: '#333' }}>
                          {item.descricaoPrincipal}
                        </div>
                        <div style={{ fontSize: '13px', color: '#999' }}>
                          {item.descricaoSecundaria}
                        </div>
                      </IonLabel>
                    </IonItem>
                  );
                })}
              </IonList>
            </IonItem>
          )}

          <IonItem lines="none">
            <IonLabel>Complemento</IonLabel>
            <IonInput
              placeholder="Apartamento, bloco, etc."
              value={complemento}
              autoCorrect='true'
              autoCapitalize='true'
              onIonInput={(e: any) => setComplemento(e.target.value)}
            ></IonInput>
          </IonItem>


          {/* <IonItem lines="none">
            <IonLabel>Descrição</IonLabel>
            <IonInput placeholder="Descrição" value={descricaoProjeto}
              autoCorrect='true' autoCapitalize='true'
              required onIonInput={(e: any) => setDescricaoProjeto(e.target.value)}></IonInput>
          </IonItem> */}

          <IonItem lines="none">
            <IonLabel>Responsáveis</IonLabel>
            <IonItem slot="end" lines="none" button={true} detail={false} onClick={e => { setShowModalResponsaveis(true); }}>
              {selectedResponsaveisText}
            </IonItem>
            <IonModal isOpen={showModalResponsaveis} onDidDismiss={() => setShowModalResponsaveis(false)} >
              <AppTypeaheadList
                title="Responsáveis"
                items={responsaveis}
                selectedItems={selectedResponsaveis}
                onSelectionCancel={() => setShowModalResponsaveis(false)}
                onSelectionChange={responsavelSelectionChanged}
              />
            </IonModal>
          </IonItem>

        </IonList>

        <IonModal isOpen={(Array.isArray(listaEnderecos) && listaEnderecos.length > 0)} onDidDismiss={() => { setListaEnderecos([]); }}>
          <IonHeader className="ion-no-border">
            <IonToolbar>
              <IonTitle>Selecione um endereço</IonTitle>
              <IonButtons slot="start" onClick={() => setListaEnderecos([])}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList>
              {readListaEnderecos()}
            </IonList>
          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={(e) => {

              mostartAlerta({
                backdropDismiss: false,
                header: 'Número',
                message: 'Adicione Número',
                inputs: [
                  {
                    name: 'mensagem',
                    type: 'textarea',
                    id: 'name2-id',
                    placeholder: 'Digite aqui o número',
                  }],
                buttons: ['Cancel', {
                  text: 'OK', handler: (d) => {
                    setLocal(localEnderecoSelecionado + ", " + d.mensagem);
                  }
                }],
                onDidDismiss: (e) => { console.log('did dismiss'); }
              })

              setListaEnderecos([]);
            }}>Avançar</IonButton>
          </IonFooter>
        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>
      <IonFooter className="ion-no-border" >
        <IonToolbar>
          <IonButton disabled={!botaoAtivo} expand="block" size='large' color="primary" onClick={async () => {

            if (!validarCampos())
              return;

            if (botaoAtivo) {
              setShowLoading(true);
              setBotaoAtivo(false);
              let response = await CriarCliente().catch((error) => {
                console.log("error.message", error.message);
                setTextToast(error.message);
                setShowToast(true);
                if (error.data) {
                  console.log("entrou varios endereços");
                  if (Array.isArray(error.data) && error.data.length > 0) {
                    setListaEnderecos(error.data);
                  }
                }
              });
              console.log("********** CriarCliente", response);
              if (response && response.usuario) {
                let responseProjeto = await inserirProjeto(response).catch((error) => {
                  console.log("error.message", error.message);
                  setTextToast(error.message);
                  setShowToast(true);
                });
                if (responseProjeto && responseProjeto.message) {
                  props.salvarAction();
                  setRecarregarProjeto(true);
                }
              }
              setShowLoading(false);
              setBotaoAtivo(true);


            }

          }}>Registrar</IonButton>
        </IonToolbar>
      </IonFooter>
    </>
  );

};

export default ({ dadosVenda, inputRef, closeAction, salvarAction }: { dadosVenda: any, inputRef: any, closeAction: Function, salvarAction: Function }) => (
  <VendasCriarProjeto dadosVenda={dadosVenda} inputRef={inputRef} closeAction={closeAction} salvarAction={salvarAction}>
  </VendasCriarProjeto>
)
